import './App.css';
import Header from './Components/Header/Header';
import Teacher from './Components/Teacher/Teacher';

function App() {
  return (
    <div className="App">
      <Header />
      <Teacher />
    </div>
  );
}

export default App;
